<template>
    <div class="inputSearch">
      <lk-dropdown trigger="custom" placement="bottom-start" :visible="visible" @on-click="onDropDownClick" ref="dropdown"
        style="width: 750px">
        <lk-input suffix="ios-search" placeholder="请输入商品编码/通用名/商品名" @on-change="onInputChange" v-model="value" ref='search' @on-blur='inputBlur' @on-focus="onInputChange">
        </lk-input>
        <lk-dropdown-menu slot="list" class="searchList" ref="outer">
          <div class="inner" ref="inner">
          <lk-dropdown-item disabled name='title' >
            <div class="options">
              <span>商品编码</span>
              <span>商品通用名</span>
              <span>商品名</span>
              <span>规格</span>
              <span>生产企业</span>
              <span>单位</span>
            </div>
          </lk-dropdown-item>
          <lk-dropdown-item v-for="(item, index) in options" :key="index" :name='index'>
            <div :class="{'options':true,}" >
              <span>{{item.goodsBase.drugSerialCode}}</span>
              <span>{{item.goodsBase.approvedDrugNames}}</span>
              <span>{{item.goodsBase.goodsName}}</span>
              <span>{{item.goodsBase.specifications}}</span>
              <span>{{item.goodsBase.manufacturer}}</span>
              <span>{{item.goodsBase.drugMiniPackageUnitString}}</span>
            </div>
          </lk-dropdown-item>
          </div>
        </lk-dropdown-menu>
      </lk-dropdown>
    </div>
  </template>
<script>
import utils from '../../../libs/utils';
import goodsService from '../../../services/goods';

export default {
  name: 'inputSearch',
  props: {
    autoFocus: {
      type: Boolean,
      default: false,
    },
    selectedList: {
      type: Array,
    },
    retailType: {
      type: Number,
    },
    purchaseType: {
      type: Number,
    },
  },
  data() {
    return {
      value: '',
      visible: false,
      selectLoading: false,
      selectedIndex: null,
      options: [],
      timer: null,
      tips: '',
    };
  },
  methods: {
    onInputChange() {
      clearTimeout(this.timer);
      this.timer = setTimeout(this.getData, 500);
    },
    getData() {
      if (this.value) {
        const params = {
          nameMix: this.value,
          type: 1,
        };
        this.tips = '';
        goodsService.listGoodsBases(params).then((res) => {
          if (res.data.status === 200) {
            this.options = [];
            if (res.data.data && res.data.data.list.length && this.value) { // 控制异步查询搜索词为空展示问题
              this.visible = true;
              this.options = res.data.data.list;
              this.selectedIndex = 0;
            } else {
              this.visible = false;
            }
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      } else {
        this.options = [];
        this.visible = false;
      }
    },
    onDropDownClick(name) {
      if (this.selectLoading || name === 'title') {
        this.selectLoading = false;
        this.visible = false;
        this.$nextTick(() => {
          this.$refs.dropdown.currentVisible = false; // 规避iview组件不能驱动内部参数问题
        });
      } else {
        this.visible = true;
        this.selectLoading = true;
        if (!isNaN(name)) {
          this.selectedIndex = name;
          this.selected();
          this.$nextTick(() => {
            this.visible = false;
          });
        }
        setTimeout(() => {
          this.selectLoading = false;
        }, 500);
      }
    },
    inputBlur() {
      this.$nextTick(() => {
        this.visible = false;
      });
    },
    onKeydown() {
    },
    focus() {
      this.$refs.search.focus();
    },
    selected(id) {
      this.visible = false;
      this.value = '';
      this.$emit('selected', id || this.options[this.selectedIndex]);
    },
    handleSearchKey(e) {
      if (this.visible) {
        const { key } = e;
        const outer = this.$refs.outer.$el;
        if (key === 'ArrowDown' && (this.selectedIndex < this.options.length - 1)) {
          this.selectedIndex++;
          outer.scrollBy(0, 34);
        } else if (key === 'ArrowUp' && (this.selectedIndex > 0)) {
          this.selectedIndex--;
          outer.scrollBy(0, -34);
        } else if (key === 'Enter') {
          this.selected(); this.$emit('on-keydown', e);
          outer.scrollTo(0, 0);
        }
      }
      if (e.key === 'z' && e.ctrlKey) {
        this.$emit('swichKeyDown', e, 'goods0');
      }
    },
    clearValue() {
      this.value = '';
    },
  },
  mounted() {
    this.value = '';
    if (this.autoFocus) {
      this.$nextTick(() => {
        this.$refs.search.focus();
      });
    }
  },
};
</script>
  <style lang="less" scoped>
  .searchList{
    max-height: 300px;
    overflow: auto;
  }
  .selected{
    background: #f8f8f8
  }
  .options{
    // width: auto;
    display: flex;
    align-items: center;
    font-size: 12px;

    >span{
      // width: 15%;
    flex-shrink: 0;
      box-sizing:content-box;
      text-align: left;
      word-wrap: none;
      text-overflow: ellipsis;
      overflow: hidden;
      padding: 0 16px

    }
    >span:last-child{
      padding-right: 0

    }
          >span:nth-child(1){
            padding-left: 0;
            width: 60px
          }
          >span:nth-child(2){
            // padding-left: 0;
            width: 100px
          }
    >span:nth-child(3){
      width: 135px
    }
    >span:nth-child(4){
      width: 135px
    }
    >span:nth-child(5){
      width: 70px
    }
    >span:nth-child(6){
      width: 130px
    }
    >span:nth-child(7){
      width: 70px
    }
    >span:nth-child(8){
      width: 48px
    }
    >span:nth-child(9){
      width: 48px
    }
    >span:nth-child(10){
      width: 48px
    }
    .textOver{
      width: 100%;
      text-align: left;
      word-wrap: none;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .inputSearch{
    display: flex;
    align-items: center;
  }
  .tips{
    padding-left: 8px;
    color: #ed4014;
  margin-right: -500px
  }
  </style>
